import { BodyText, LayoutBox } from '@bamboohr/fabric';
import NavPrompt from './NavPrompt';
import { Chat, LlmConfig } from 'src/types/global';

interface SideBarGroupsProps {
	chats: Chat[];
	sessionTitle: string;
	loadChatLogs: (
		chatID: string,
		chatName: string,
		label: string,
		id: string,
		newConfig: LlmConfig,
	) => void;
	setChatName: (name: string) => void;
	setChatNames: (chats: Chat[]) => void;
	chatNames: Chat[];
	activeId: string;
}

export const getSessionGroupTitle = (sessionTitle: string): string => {
	switch (sessionTitle) {
		case 'todaySessions':
			return 'Today';
		case 'last7DaysSessions':
			return 'Previous 7 Days';
		case 'last30DaysSessions':
			return 'Previous 30 Days';
		default:
			return 'Older';
	}
};

const SideBarGroups = ({
	loadChatLogs,
	sessionTitle,
	chats,
	chatNames,
	setChatNames,
	setChatName,
	activeId,
}: SideBarGroupsProps) => {
	if (chats.length === 0) return null;

	const title = getSessionGroupTitle(sessionTitle);

	return (
		<>
			<div className="categoryContainer">
				<LayoutBox marginLeft="12px" marginBottom="8px">
					<BodyText
						size="extra-small"
						justify="start"
						color="neutral-weak"
						weight="regular"
					>
						{title}
					</BodyText>
				</LayoutBox>
				{chats.map((chat) =>
					chat.name ? (
						<NavPrompt
							key={chat.id}
							chat={chat}
							loadChatLogs={loadChatLogs}
							setChatName={setChatName}
							chatNames={chatNames}
							setChatNames={setChatNames}
							isActive={activeId === chat.id}
						/>
					) : null,
				)}
			</div>
		</>
	);
};

export default SideBarGroups;
